const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(-2.25 -1.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23172",
  "data-name": "Path 23172",
  d: "M26.25,8.806V22.386a3.657,3.657,0,0,1-.991,2.515,3.309,3.309,0,0,1-2.394,1.041H5.635A3.309,3.309,0,0,1,3.241,24.9a3.657,3.657,0,0,1-.991-2.515V8.806a3.657,3.657,0,0,1,.991-2.515A3.309,3.309,0,0,1,5.635,5.25H22.865a3.309,3.309,0,0,1,2.394,1.041A3.657,3.657,0,0,1,26.25,8.806ZM8.1,18.506a.924.924,0,1,0,1.846,0V16.889h1.846v1.617a.924.924,0,1,0,1.846,0v-3.88a2.842,2.842,0,0,0-2.769-2.91A2.842,2.842,0,0,0,8.1,14.626Zm3.692-3.556H9.942v-.323a.924.924,0,1,1,1.846,0Zm3.077,3.556a.948.948,0,0,0,.923.97h1.846a2.842,2.842,0,0,0,2.769-2.91v-1.94a2.842,2.842,0,0,0-2.769-2.91H15.788a.948.948,0,0,0-.923.97Zm1.846-.97v-3.88h.923a.948.948,0,0,1,.923.97v1.94a.948.948,0,0,1-.923.97Z",
  transform: "translate(0 -0.481)",
  fill: "#afc8e9",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23173",
  "data-name": "Path 23173",
  d: "M8.475,3.05a1.125,1.125,0,1,1,1.8-1.35l3.6,4.8,3.6-4.8a1.125,1.125,0,1,1,1.8,1.35l-4.5,6a1.125,1.125,0,0,1-1.8,0Z",
  transform: "translate(0.375)",
  fill: "#afc8e9",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23174",
  "data-name": "Path 23174",
  d: "M19,23.125a1.125,1.125,0,0,1-2.25,0v-2.25a1.125,1.125,0,0,1,2.25,0Z",
  transform: "translate(3.021 3.461)",
  fill: "#afc8e9",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23175",
  "data-name": "Path 23175",
  d: "M8,23.125a1.125,1.125,0,0,1-2.25,0v-2.25a1.125,1.125,0,0,1,2.25,0Z",
  transform: "translate(0.729 3.461)",
  fill: "#afc8e9",
  fillRule: "evenodd"
}));
function SvgAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26.461,
    viewBox: "0 0 24 26.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.00bab70e73c69794985a9b6d3525533a.svg";
export { ForwardRef as ReactComponent };